export default ({
    name : 'ProductBest'
    , data () {
        return {
            productList : []
            , originProductList : []
            , viewCart : viewCart
        }
    }
    , created () {
        this.code = 'product_best';
        this.basic = this.getDetailDataByCode(this.code);
        if (
            typeof this.basic.data.product_list !== 'undefined' && 
            typeof this.basic.data.product_list.value !== 'undefined' && 
            this.basic.data.product_list.value.length > 0
        ) {
            this.originProductList = this.basic.data.product_list.value; 
            this.setProductListFromChangedLimit();
        }
        sessionStorage.setItem('productId', this.basic.data.product_id.value);
        return {}
    }
    , mounted () {
        if (this.getAdminEditMode()) {
            this.settingOnContentShow()
        }
    }
    , computed : {
        isShowType1 () {
            if (this.getShowTypeValue() == this.getShowTypeEnumValue(0)) return true;
            return false;
        }
        , isShowType2 () {
            if (this.getShowTypeValue() == this.getShowTypeEnumValue(1)) return true;
            return false;
        }
        , isShowType3 () {
            if (this.getShowTypeValue() == this.getShowTypeEnumValue(2)) return true;
            return false;
        }
        , isShowType4 () {
            if (this.getShowTypeValue() == this.getShowTypeEnumValue(3)) return true;
            return false;
        }
        , title () {
            if (this.basic.data.title.value.length == 0) return this.basic.data.title.default
            return this.basic.data.title.value
        }
        , rows () {
            let def  = (isNaN(parseInt(this.basic.data.rows.default))) ? 4 : parseInt(this.basic.data.rows.default)
            let rows = (isNaN(parseInt(this.basic.data.rows.value))) ? def : parseInt(this.basic.data.rows.value)
            return rows
        }
        , column () {
            let def     = (isNaN(parseInt(this.basic.data.column.default))) ? 1 : parseInt(this.basic.data.column.default)
            let column  = (isNaN(parseInt(this.basic.data.column.value))) ? def : parseInt(this.basic.data.column.value)
            return column
        }
        , changeRowsEng () {
            switch (this.rows) {
                case 2: return 'two'
                case 3: return 'three'
                case 4: return 'four'
                case 5: return 'five'
            }
            return 'four'
        }
        , isDefaultValue () {
            return (this.productList.length < 1 || this.basic.data.product_id.value.length < 1)
        }
        , productBestDefaultImg () {
            return `//image.makeshop.co.kr/mysoho/assets/shop/img/temp/noimg_product_best.png`
        }
    }
    , methods : {
        getShowTypeValue () {
            return this.basic.data.show_type.value;
        }
        , getShowTypeEnumValue (key) {
            return this.basic.data.show_type.enums[key];
        }
        , getLimit () {
            let limit = Number(this.basic.data.rows.value) * Number(this.basic.data.column.value)
            //if (this.getAdminEditMode()) limit = Number(this.basic.data.rows.value)
            if (limit > this.originProductList.length) return this.originProductList.length
            return limit
        }
        , getProductBestList () {
            let params = new FormData()
            params.append('limit', this.basic.data.product_id.value.length)
            params.append('prd_ids', this.basic.data.product_id.value)

			this.$http.post(`${this.baseURI}${this.displayDataUrl['product_best']}`, params, { headers : this.axiosCommonHeader }
            ).then(response => {
                if (response.data.length == 0) {
                    return
                }
                this.originProductList = response.data.list
                this.setProductListFromChangedLimit()
            }).catch(error => {
                return
            })
        }
        , getPayUrl (productId, stockType) {
            if (this.isSoldOutStockType(stockType)) {
                return 'javascript:void(0);'
            }
            return 'javascript:check_cart(' + productId + ');'
        }
        , goPayUrl (productId, stockType) {
            if (this.getAdminEditMode() || this.isSoldOutStockType(stockType)) {
                return false
            }
            return check_cart(productId)
        }
		, getCartUrl (stockType) {
            if (this.isSoldOutStockType(stockType)) {
                return 'MSH-display-none'
            }
            return (viewCart) ? 'MSH-btn-cart-add' : 'MSH-display-none'
        }
        , getSoldoutClassName (stockType) {
            if (this.isSoldOutStockType(stockType)) return 'soldout'
            return ''
        }
        , isSoldOutStockType (stockType) {
            if (stockType == 'soldout') return true
            return false
        }
        , setProductListFromChangedLimit () {
            let product = []
            let productIds = []
            if (this.originProductList.length == 0) { 
                this.productList = product 
                return
            }
            for (let i=0; i < this.getLimit(); i++) {
                product[i] = this.originProductList[i]
                productIds[i] = this.originProductList[i].prd_id
            }
            this.productList = product 
        }
        , isMoreGetProductBestList () {
            let prdIds = this.basic.data.product_id.value
            let storagePrdIdStr = sessionStorage.getItem('productId')
            let storagePrdIds = storagePrdIdStr.split(',')
            let isMore = false
            let sortProductList = []
            for (let i=0; i < prdIds.length; i++) {
                let chkPrdId = prdIds[i].toString()
                if (storagePrdIds.indexOf(chkPrdId) < 0) {
                    isMore = true
                    break
                }
            }
            if (isMore === true) {
                sessionStorage.setItem('productId', this.basic.data.product_id.value)
                this.getProductBestList()
                return
            }
            // sort 
            for (let i=0; i< prdIds.length; i++) {
                let chkPrdId = prdIds[i].toString()
                let idx = storagePrdIds.findIndex(function(v) { 
                    return v == chkPrdId
                })
                sortProductList[i] = this.originProductList[idx]
            }
            this.originProductList = sortProductList
            this.setProductListFromChangedLimit()
            sessionStorage.setItem('productId', this.basic.data.product_id.value)
        }
        , getOriginProductListItem (prdId) {
            let origin = this.originProductList
            let retIdx = 0
            for (let i=0; i < origin.length; i++) {
                if (origin[i].prd_id == prdId) {
                    retIdx = i
                }
            }
            return retIdx
        }
        , showContent (index) {
            document.querySelectorAll('.bestItem-box div.cntInner')[index].style.display = 'block';
        }
        , hideContent (index) {
            document.querySelectorAll('.bestItem-box div.cntInner')[index].style.display = 'none';
        }
        , settingOnContentShow () {
            let _code = this.code
            $m(document).on('mouseover', '#settingArea-'+_code, function() {
                let _el = $m('#settingArea-'+_code)
                if (_el.parent().find('.imgInner').length > 0) {
                    _el.parent().find('.cntInner').show()
                }
            })
            $m(document).on('mouseleave', '#settingArea-'+_code, function() {
                let _el = $m('#settingArea-'+_code)
                if (_el.parent().find('.imgInner').length > 0) {
                    _el.parent().find('.cntInner').hide()
                }
            })
        }
    }
    , updated () {
        if (this.getAdminEditMode()) {
            if (this.basic.data.product_id.value.length > 0 && this.basic.data.product_id.value != sessionStorage.getItem('productId')) {
                this.isMoreGetProductBestList()
            }
            if (this.getLimit() > this.productList.length) {
                this.setProductListFromChangedLimit()
            }
        }
    }
})
